import React,{useEffect,useState} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useIntl } from 'react-intl';
import { IconButton, Tooltip, Fade } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import { ProductInputData } from '../../redux/product/productTypes';
import { ClampexType } from '../../types/types';

const StyledTableCell = withStyles(theme => ({
  head: {
    color: theme.palette.third.main,
    fontWeight: 700
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);


const useStyles = makeStyles(theme => ({
  form: {
    display: 'flex',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
  dialogContent: {
    color: theme.palette.text.primary
  },
  button: {
    //@ts-ignore
    backgroundColor: theme.palette.third.main,
    padding: "5px"
  },
}));



/********************************************************************
 * This function loads all selections stored in the local browser storage
 *******************************************************************/
const loadDateFromLocalStorage = (clampexType: ClampexType): Array<ProductInputData | null> => {

  const keys = Object.keys(localStorage);
  const savedSelections: Array<ProductInputData | null> = [];
  keys.forEach(element => {
    
    if(element.includes(clampexType)) {
      //@ts-ignore
      savedSelections.push(JSON.parse(window.localStorage.getItem(element)) as ProductInputData);
    }

  });
  return savedSelections;
}

/*************************************************
 * Deletes the selected entry from local browser storage
 * @param productInputData the selection to be deleted
 *************************************************/
const deleteSelection = (productInputData: ProductInputData) => {
    window.localStorage.removeItem(productInputData.storageKey || "");
}

interface Props {
  open: boolean,
  onClose(): any,
  clampexType: ClampexType,
  loadSelection(selection: ProductInputData): any
}


export default function SavedSelectionDialog(props: Props) {
  const classes = useStyles();
  const { formatMessage: f } = useIntl();
  const { onClose, open } = props;
  const [savedSelections, setSavedSelections] = useState(loadDateFromLocalStorage(props.clampexType));

  //Everytime the open variable changes load the selections from the local browser storage
  useEffect(() => {
    setSavedSelections(loadDateFromLocalStorage(props.clampexType)); 
  },[open, props.clampexType])

  const handleClose = () => {
    onClose();
  };


  return (
    <div>
      <Dialog
        maxWidth="md"
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="max-width-dialog-title">
          {f({ id: 'app.loaddialog.heading', defaultMessage: 'Load saved drawing.' })}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText className={classes.dialogContent}>
            {f({ id: 'app.loaddialog.text', defaultMessage: '' })}
          </DialogContentText>
          <Paper>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <StyledTableCell>{f({ id: 'app.loaddialog.table.date', defaultMessage: '' })}</StyledTableCell>
                  <StyledTableCell align="right">{f({ id: 'app.labelSpannelement', defaultMessage: '' })}</StyledTableCell>
                  <StyledTableCell align="right">{f({ id: 'app.labelDrehmom', defaultMessage: '' })}</StyledTableCell>
                  <StyledTableCell align="right">{f({ id: 'app.labelAxialkraft', defaultMessage: '' })}</StyledTableCell>
                  <StyledTableCell align="right">{f({ id: 'app.labelDrehzahl', defaultMessage: '' })}</StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {  //iterate through all selections saved in the browser storage and display them.
                  savedSelections.map((val, index) => {
                    if (val !== null) {
                      return (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {val.date}
                          </TableCell>
                          <TableCell align="right">
                            {val.shaftDiameter_d}x{val.hubInnerDiameter_D}
                          </TableCell>
                          <TableCell align="right">{val.torque}</TableCell>
                          <TableCell align="right">{val.axialForce}</TableCell>
                          <TableCell align="right">{val.rotationSpeed}</TableCell>
                          <TableCell align="right">
                            <Tooltip enterDelay={500} TransitionComponent={Fade} title={f({ id: 'app.loaddialog.load', defaultMessage: 'Load' })}>
                              <IconButton onClick={() => { props.loadSelection(val) }} className={classes.button}>
                                <GetAppIcon style={{ fontSize: "1em" }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip enterDelay={500} TransitionComponent={Fade} title={f({ id: 'app.loaddialog.delete', defaultMessage: 'Delete' })}>
                              <IconButton onClick={() => { deleteSelection(val); setSavedSelections(loadDateFromLocalStorage(props.clampexType)); }} style={{ marginLeft: "2px" }} className={classes.button}>
                                <DeleteIcon style={{ fontSize: "1em" }} />
                              </IconButton>
                            </Tooltip>
                          </TableCell>

                        </TableRow>
                      );
                    } else {
                      return (null)
                    }
                  })
                }
              </TableBody>
            </Table>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {f({ id: 'app.loaddialog.close', defaultMessage: 'Close' })}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}